import Form from "./Form/Form";
import image from "../asset/undraw_fill_form_re_cwyf.png";
import "./ContactMe.css"
function ContactMe() {
  return (
    <main className="container ContactForm">
      <div className="row">
        <div className="col-md">
          <Form />
        </div>
        <div className="col-md">
          <img src={image} alt="fill form" />
        </div>
      </div>
    </main>
  );
}

export default ContactMe;
